
export const extractNumber = (output) => {
    if (typeof output === 'number') {
        return output;
    }

    const str = String(output).trim();
    const matches = str.match(/-?\d+(\.\d+)?/g);

    if (!matches) {
        return null;
    }

    return parseFloat(matches[0]);
};

export const extractNumbers = (output) => {
    if (typeof output === 'number') {
        return [output];
    }

    const str = String(output).trim();
    const matches = str.match(/-?\d+(\.\d+)?/g);

    if (!matches) {
        return [];
    }

    return matches.map(Number);
};

export const getRandomInt = (min, max, exclusions = []) => {
    let randomInt;
    do {
        randomInt = Math.floor(Math.random() * (max - min + 1)) + min;
    } while (exclusions.includes(randomInt));
    return randomInt;
};